module.exports = __webpack_public_path__ + "static/media/sensor-on.6625c827.svg";